"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_1 = require("@material-ui/core/styles");
var Card_1 = __importDefault(require("@material-ui/core/Card"));
var CardActionArea_1 = __importDefault(require("@material-ui/core/CardActionArea"));
var CardContent_1 = __importDefault(require("@material-ui/core/CardContent"));
var CardMedia_1 = __importDefault(require("@material-ui/core/CardMedia"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var ProductDetail_1 = __importDefault(require("./ProductDetail"));
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            minHeight: 300,
            maxWidth: 300,
            width: '80%',
            minWidth: 250,
            marginLeft: '50%',
            transform: 'translate(-50%)'
        },
        media: {
            height: 240,
        },
        title: {
            margin: 0,
            padding: theme.spacing(1),
            textAlign: "center"
        },
        body: {
            minHeight: 60,
            margin: 0,
            textAlign: "center"
        }
    });
});
var ProductItem = function (props) {
    var classes = useStyles();
    var _a = react_1.useState(false), open = _a[0], setOpen = _a[1];
    var handleClickOpen = function () {
        setOpen(true);
    };
    var handleClose = function () {
        setOpen(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Card_1.default, { className: classes.root, onClick: handleClickOpen },
            react_1.default.createElement(CardActionArea_1.default, null,
                react_1.default.createElement(CardMedia_1.default, { className: classes.media, image: props.image, title: props.title }),
                react_1.default.createElement(CardContent_1.default, { className: classes.body },
                    react_1.default.createElement(Typography_1.default, { className: classes.title }, props.title),
                    react_1.default.createElement(Typography_1.default, null, props.content)))),
        react_1.default.createElement(ProductDetail_1.default, { type: props.type, info: props.info, open: open, onClose: handleClose })));
};
exports.default = ProductItem;
